export type WhatsappBspCompletionMessages = {
  whatsappBspCompletionText1: string;
  whatsappBspCompletionText2: string;
  whatsappBspCompletionPhoneNumber: string;
  whatsappBspCompletionStatus: string;
  whatsappBspCompletionStatusActive: string;
};

export const whatsappBspCompletionMessages: WhatsappBspCompletionMessages = {
  whatsappBspCompletionText1: "Parabéns! 🎉",
  whatsappBspCompletionText2:
    "Seu WhatsApp está conectado e pronto para receber clientes.",
  whatsappBspCompletionPhoneNumber: "Número de telefone:",
  whatsappBspCompletionStatus: "Status:",
  whatsappBspCompletionStatusActive: "Ativo",
};

